import React from "react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import cards10 from "../../images/cards/cards-10.png";

const BlogPreviewCarousel = ({ images }) => {
    // If images is empty or not an array, use [cards10] as fallback
    const displayImages =
        Array.isArray(images) && images.length > 0 ? images : [cards10];

    return (
        <div className="rounded-sm bg-white dark:border-strokedark dark:bg-boxdark h-60 overflow-hidden">
            <div className=" h-full">
                <Swiper
                    className="carouselOne h-full"
                    modules={[Navigation]}
                    navigation={{
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }}
                >
                    {displayImages.map((img, idx) => (
                        <SwiperSlide key={idx} className="h-full">
                            <img
                                src={img}
                                alt={`carousel-${idx}`}
                                className="object-contain w-full h-full rounded"
                            />
                        </SwiperSlide>
                    ))}
                    {/* Navigation buttons */}
                    <div className="swiper-button-prev">
                        <svg
                            className="fill-current"
                            width="12"
                            height="20"
                            viewBox="0 0 12 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.2344 19.4875C10.0094 19.4875 9.78438 19.4125 9.63437 19.225L1.15937 10.6C0.821875 10.2625 0.821875 9.73748 1.15937 9.39997L9.63437 0.774976C9.97188 0.437476 10.4969 0.437476 10.8344 0.774976C11.1719 1.11248 11.1719 1.63748 10.8344 1.97498L2.95937 9.99998L10.8719 18.025C11.2094 18.3625 11.2094 18.8875 10.8719 19.225C10.6469 19.375 10.4594 19.4875 10.2344 19.4875Z"
                                fill=""
                            />
                        </svg>
                    </div>
                    <div className="swiper-button-next">
                        <svg
                            className="fill-current"
                            width="12"
                            height="20"
                            viewBox="0 0 12 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1.75938 19.4875C1.53438 19.4875 1.34687 19.4125 1.15937 19.2625C0.821875 18.925 0.821875 18.4 1.15937 18.0625L9.03437 9.99998L1.15937 1.97498C0.821875 1.63748 0.821875 1.11248 1.15937 0.774976C1.49687 0.437476 2.02187 0.437476 2.35937 0.774976L10.8344 9.39997C11.1719 9.73748 11.1719 10.2625 10.8344 10.6L2.35937 19.225C2.20937 19.375 1.98438 19.4875 1.75938 19.4875Z"
                                fill=""
                            />
                        </svg>
                    </div>
                </Swiper>
            </div>
        </div>
    );
};

export default BlogPreviewCarousel;
